export enum TabType {
  orientations = 'orientations',
  evaluationCriteria = 'evaluationCriteria',
  thesisTheme = 'thesisTheme',
  thesisDevelopment = 'thesisDevelopment',
  finalThesis = 'finalThesis',
}

export enum ThesisThemeItemType {
  firstTCCTheme = 'firstTCCTheme',
  waitingReview = 'waitingReview',
  themeRejected = 'themeRejected',
  themeApproved = 'themeApproved',
}

export interface ThesisThemeItem {
  type: ThesisThemeItemType;
  enabled: boolean;
  data?: any;
  isLast: boolean;
}

export enum ThesisDevelopmentItemType {
  firstSubmission = 'firstSubmission',
  waitingReview = 'waitingReview',
  adjustmentsRequested = 'adjustmentsRequested',
  developmentApproved = 'developmentApproved',
  noInteractionRemaining = 'noInteractionRemaining',
  optionalSubmission = 'optionalSubmission',
}

export interface ThesisDevelopmentItem {
  type: ThesisDevelopmentItemType;
  enabled: boolean;
  data?: any;
  isLast: boolean;
}

export enum RetryDialogAction {
  USE_SAME_THEME = 'use-same-theme',
  CHOOSE_NEW_THEME = 'choose-new-theme',
}
